<app-content-page-layout title="Shopping List">
  <p>Here you can find all the ingredients you need to buy for your saved recipes.</p>
  <ul class="list-disc list-inside mt-4">
    <li>500g Gnocchi</li>
    <li>200g Cherry Tomatoes</li>
    <li>100g Fresh Basil</li>
    <li>2 cloves Garlic</li>
    <li>50g Parmesan Cheese</li>
  </ul>
</app-content-page-layout>